import React, { useState, useEffect } from "react";
import axios from "axios";
import { CSVLink } from 'react-csv';
import { Link } from "react-router-dom";
import { FileDown } from "lucide-react";

export default function SocialNet({ check, fonction }) {
    const headers = [
        { label: "ID", key: "id" },
        { label: "Nom", key: "nom" },
        { label: "Réseau Social", key: "social" }
    ];

    const [data, setData] = useState([]);
    const [selectedSocials, setSelectedSocials] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage] = useState(20);

    useEffect(() => {
        fetchData();
    }, [currentPage]);

    const fetchData = async () => {
        try {
            const response = await axios.get('/cvs_pagination', {
                params: {
                    page: currentPage,
                    per_page: itemsPerPage
                }
            });
            setData(response.data.cvs || []); // Assure-toi que data est un tableau même si la réponse est vide
            setTotalPages(response.data.total_pages || 1); // Définit un totalPages par défaut de 1
        } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
        }
    };

    const handleCheck = (social) => {
        setSelectedSocials(prevSelected =>
            prevSelected.includes(social)
                ? prevSelected.filter(s => s !== social)
                : [...prevSelected, social]
        );
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const paginationItems = () => {
        const visiblePages = [];
        let startPage, endPage;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {
                startPage = 1;
                endPage = 5;
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 2;
                endPage = currentPage + 2;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            visiblePages.push(i);
        }

        return visiblePages.map(number => (
            <li
                key={number}
                className={`page-item ${number === currentPage ? 'active' : ''}`}
                aria-current={number === currentPage ? 'page' : undefined}
            >
                <button
                    className="page-link"
                    onClick={() => handlePageChange(number)}
                >
                    {number}
                </button>
            </li>
        ));
    };

    return (
        <>
            <div className="d-flex">
                <div className="p-2">Liste des réseaux sociaux</div>
                <div className="ml-auto p-2">
                    <CSVLink
                        data={data.map(cv => ({
                            id: `${cv.id}`,
                            nom: `${cv.nom}`,
                            social: `${cv.social}`
                        }))}
                        headers={headers}
                        className="btn btn-primary btn-sm"
                    >
                       <FileDown size={24} strokeWidth={1} /> Télécharger en format CSV
                    </CSVLink>
                </div>
            </div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">
                            <div className="form-check">
                                <input
                                    className=""
                                    type="checkbox"
                                    id="flexCheckDefault"
                                    checked={check}
                                    onChange={fonction}
                                />
                            </div>
                        </th>
                        <th scope="col">ID</th>
                        <th scope="col">Nom</th>
                        <th scope="col">Réseau Social</th>
                    </tr>
                </thead>
                <tbody>
                    {console.log(data)}
                    {data.length > 0 ? (
                        data.map(cv => (
                            <tr key={cv.id}>
                                <th scope="row">
                                    <div className="form-check">
                                        <input
                                            className=""
                                            type="checkbox"
                                            value={cv.social}
                                            id="flexCheckDefault"
                                            checked={selectedSocials.includes(cv.social)}
                                            onChange={() => handleCheck(cv.social)}
                                        />
                                    </div>
                                </th>
                                <td><strong>{cv.id}</strong></td>
                                <td>{cv.nomPrenom}</td>
                                <td>
                                <Link to={cv.linkedin} target="_blank">
                                    <i style={{ fontSize: "15px" }} className="bi bi-linkedin"></i>&nbsp;&nbsp;&nbsp;
                                </Link>
                                <Link to={cv.facebook} target="_blank">
                                    <i style={{ fontSize: "15px" }} className="bi bi-facebook"></i>
                                </Link>
                            </td>
                            <td>
                                <h6>
                                    <span className="badge badge-pill badge-primary">
                                        {cv.disponibility}
                                    </span>
                                </h6>
                            </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center">Aucune donnée disponible</td>
                        </tr>
                    )}
                </tbody>
            </table>
            <nav aria-label="Page navigation">
                <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            Précédent
                        </button>
                    </li>
                    {currentPage > 3 && (
                        <>
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(1)}
                                >
                                    1
                                </button>
                            </li>
                            {currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                        </>
                    )}
                    {paginationItems()}
                    {currentPage < totalPages - 2 && (
                        <>
                            {currentPage < totalPages - 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                            <li className="page-item">
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </button>
                            </li>
                        </>
                    )}
                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            Suivant
                        </button>
                    </li>
                </ul>
            </nav>
        </>
    );
}
